export default function () {
    $('.tab-model').on('touchstart', '.titleContainer .titleItem > .titleItem-label', function () {
        var index = $(this).parents('.titleItem').index()
        var thisContent = $(this).parents('.titleContainer').siblings('.contentContainer').children()[index]
        $(thisContent).show().siblings().hide()
    })
}